import React from 'react';
import { connect } from 'react-redux';
import { Content, Flex, Text, List, Pane } from '@leverege/ui-elements';
import Groupings from "../Groupings.js";
import ValueRenderer from "./ValueRenderer.js";
import S from './GroupingsViewer.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class GroupingsViewer extends React.Component {
  onSelectValue = event => {
    const {
      dispatch,
      sectionsState
    } = this.props;
    const {
      data: {
        id,
        section,
        value
      }
    } = event;
    if (section.allowDeselection) {
      const isSelected = sectionsState[section.id] === value?.value;
      dispatch(Groupings.setSelectedSectionValue(section.id, isSelected ? null : value.value, id));
    } else {
      dispatch(Groupings.setSelectedSectionValue(section.id, value.value, id));
    }
    window.dispatchEvent(new CustomEvent('molten.grouping.selection', {
      detail: {
        section,
        value
      }
    }));
  };
  render() {
    const {
      vertical,
      sectionsState,
      currentGrouping,
      objRef,
      aggregations
    } = this.props;
    if (objRef == null) {
      return null;
    }
    const rtn = [];
    const {
      id
    } = objRef;
    const sections = currentGrouping.sections;
    if (sections == null || sections.length === 0) {
      return null;
    }
    sections.forEach((section, sectionIndex) => {
      if (section.values == null || section.values.length === 0) {
        return;
      }
      const selected = sectionsState?.[section.id];
      const srcId = `${id}-${section.id}`;
      const selector = {
        isSelected: item => {
          return item.value === selected;
        },
        onSelect: evt => {
          this.onSelectValue({
            data: {
              id,
              section,
              value: evt.value
            }
          });
        }
      };
      const iProps = {
        aggregations: aggregations == null ? null : aggregations[section.id],
        variant: 'dataListItem'
      };
      if (vertical) {
        rtn.push(/*#__PURE__*/_jsxs(List, {
          variant: "dataListItem",
          selector: selector,
          children: [/*#__PURE__*/_jsx(List.Header, {
            children: section.name
          }), /*#__PURE__*/_jsx(List.Dynamic, {
            items: section.values,
            component: ValueRenderer,
            itemProps: iProps
          })]
        }, srcId));
      } else {
        rtn.push(/*#__PURE__*/_jsxs(Pane, {
          className: S.groupings,
          variant: "groupingsViewer",
          layout: "flex:groupingsViewer|rowMCenter|rowM",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "groupTitle",
            children: section.name
          }, `${srcId}.label`), /*#__PURE__*/_jsx(List, {
            variant: "dataListItem",
            selector: selector,
            className: S.horizontalList,
            children: /*#__PURE__*/_jsx(List.Dynamic, {
              items: section.values,
              component: ValueRenderer,
              itemProps: iProps
            })
          }, srcId)]
        }, `groupingsViewer-${section.id}`));
      }
    });
    if (rtn.length === 0) {
      return null;
    }
    return /*#__PURE__*/_jsx(Content, {
      relative: true,
      className: S.content,
      children: /*#__PURE__*/_jsx(Content.Area, {
        children: /*#__PURE__*/_jsx(Flex, {
          direction: vertical ? 'column' : 'row',
          children: rtn
        })
      })
    });
  }
}
export default connect((state, props) => {
  // Do some calculation/data retrieval as necessary
  const {
    relationship
  } = props;
  const {
    grouping,
    objRef
  } = Groupings.getGroupingAndObjRef(state);
  return {
    sectionsState: Groupings.getSelectedSectionValues(state) || {},
    currentGrouping: grouping,
    objRef,
    aggregations: Groupings.getGroupingAgg(state, relationship.path)
  };
})(GroupingsViewer);